import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JobLogService } from '@eadsysteme/joblogclient-v1';
import { SessionService } from '../../app/services/session.service';

@Injectable({
	providedIn: 'root',
})
export class JobStateService {
	private _allJobsFinished = false;
	private allJobsFinished$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this._allJobsFinished);
	private isDialogOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public openDialog() {
		this.isDialogOpen$.next(true);
	}

	public closeDialog() {
		this.isDialogOpen$.next(false);
	}

	public isDialogOpen() {
		return this.isDialogOpen$.asObservable();
	}

	public getAllJobsFinished(): Observable<boolean> {
		return this.allJobsFinished$.asObservable();
	}

	public setAllJobsFinished(value: boolean): void {
		this.allJobsFinished$.next(value);
		this._allJobsFinished = value;
	}

	get allJobsFinished(): boolean {
		return this._allJobsFinished;
	}

	async setJobStatusPolled(jobLogService: JobLogService, sessionService: SessionService) {
		do {
			await this.delay(5000);
			this.setJobStatusByRunningJobs(jobLogService, sessionService);
		} while (!this.allJobsFinished$.getValue());
	}

	private setJobStatusByRunningJobs(jobLogService: JobLogService, sessionService: SessionService) {
		jobLogService.getLatestJobLogs(sessionService.effectiveArea).subscribe((jobLogsResponse) => {
			if (jobLogsResponse.length == 0) {
				this.setAllJobsFinished(true);
			} else {
				const booleans = [...new Set(jobLogsResponse.map((jobLog) => jobLog.jobStatus == 'FINISHED' || jobLog.jobStatus == 'ERROR'))];
				this.setAllJobsFinished(booleans.length == 1 && booleans.includes(true));
			}
		});
	}

	delay(ms: number) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}
}
